<template>
  <section class="ebill">
    <div class="row">
      <div class="col-lg-6">
        <div class="bg-image" v-bind:style="'background-image: url('+require('./../assets/img/ebill.webp')+')'">
          <div class="mobile" v-bind:style="'background-image: url('+require('./../assets/img/'+background)+')'">

          </div>
        </div>
      </div>

      <div class="col-lg-6 ebill-class">
        <div class="ebill-info">
          <div class="row">
            <div :class="width >= 486 ? 'col-xs-4' : 'col-sm-4'">
              <h1 class="title">{{ messages.ebill.title }}</h1>
            </div>
            <div
                :class="width >= 486 ? 'col-xs-7' : 'col-sm-7'"
                :style="width >= 486 ? 'display: flex; justify-content: end;align-items: center;' : 'display: flex;align-items: center;margin: 15px 0px 15px 0px;'"
            >
              <a class="btn-smartville" v-if="messages.ebill?.button" :href="messages.ebill?.button.href" target="_blank">
                {{ messages.ebill?.button.text }}
              </a>
            </div>
          </div>
          <h1 class="content">{{ messages.ebill.text1 }}</h1>
          <h1 class="content-list">{{ messages.ebill.text2 }}</h1>
          <ul class="list">
            <li v-for="(item,index) in messages.ebill.list"
                :key="index"
            >
              {{ item.text }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "ebill_component",
  data(){
    return {
      messages:{},
      active:0,
      background:'',
      width: window.innerWidth,
    };
  },
  methods:{
    select(index){
      this.active = index;
      this.background = this.messages.ebill.list[index].image;
    }
  },
  beforeMount() {
    this.messages = window.messages;
    this.background = this.messages.ebill.list[0].image;
  },
  mounted() {
    window.addEventListener('scroll', () => {
      const div = document.querySelector(".ebill")

      if (document.documentElement.scrollTop > div.scrollTop + 900) {
        div.querySelector(".bg-image").classList.add('fadeInDown');
        div.querySelector(".bg-image").querySelector(".mobile").classList.add('fadeInDown');
      }
    });
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
    }, true);
  },
}
</script>

<style scoped>

</style>